// Packages and components
import React, { useEffect } from 'react';
import SHDContainer from '@ui/Container/SHDContainer';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';

// Utilities and helpers
import { useImportTeamSnap } from '@hooks/useTeam';
import { useLocation } from 'react-router-dom';

// Types and interfaces
const TeamSnapCallback: React.FC = () => {
  // Hooks and contexts
  const location = useLocation();

  const { postAccessToken, error } = useImportTeamSnap();

  useEffect(() => {
    const getAccessToken = () => {
      const query = new URLSearchParams(location.hash.slice(1));
      const accessToken = query.get('access_token');
      return accessToken;
    };
    const accessToken = getAccessToken();
    if (accessToken) {
      postAccessToken(accessToken);
    }
  }, [location, postAccessToken]);

  return (
    <SHDThemeOverride>
      <SHDContainer align="center" justify="center">
        <SHDHeading level={3}>Redirecting you back to sign up...</SHDHeading>
        {error && (
          <SHDHeading level={3}>
            Error: {error.message} Please try again
          </SHDHeading>
        )}
      </SHDContainer>
    </SHDThemeOverride>
  );
};

export default TeamSnapCallback;
